const SINGLE_TIER_ONE = "£1,245"
const SINGLE_TIER_TWO = "£1,495"
const SINGLE_TIER_THREE = "£1,745"
const COUPLE_TIER_ONE = "£1,800"
const COUPLE_TIER_TWO = "£2,000"
const COUPLE_TIER_THREE = "£2,250"

export { SINGLE_TIER_ONE, SINGLE_TIER_TWO, SINGLE_TIER_THREE, COUPLE_TIER_ONE, COUPLE_TIER_TWO, COUPLE_TIER_THREE }